/* ============================================================
   tio-cyber.js — el contador y el codigo del Modo Cyber.

   Solo se carga con el modo encendido (layout/theme.liquid).

   EL CONTADOR. [data-tio-cyber] trae la hora de termino en data-fin
   (segundos, la calcula Liquid) y aca se resta contra el reloj del
   navegador, una vez por segundo. Cada numero vive en su caja y solo se
   reescribe el que cambio. Liquid ya deja escrito el tiempo que faltaba
   al armar la pagina, asi que sin JS el contador se ve igual, quieto.
   Al llegar a cero la barra se esconde y se quita la clase tio-cyber
   del <body>: el sitio vuelve a su aspecto de siempre sin recargar (el
   header sube solo: el alto de la barra colgaba de esa clase).

   REINICIO CADA NOCHE (8-oct-2026, "como decantslab que se reinicia cada
   24hrs"). Si la barra trae data-diario, pasada la fecha oficial no se
   esconde: cuenta hasta la medianoche del dia (hora del celular, igual
   que decantslab) y al pasarla vuelve a 23:59:59. Nunca mas de 23:59:59.

   EL CODIGO. Todo lo que lleve [data-tio-cyber-copiar] copia su
   data-codigo al tocarlo y lo dice ("Copiado") por un momento. Un solo
   listener delegado (doctrina 8.1). Hoy lo lleva solo la etiqueta del
   hero: el dueno pidio sacar el codigo del contador (2-oct-2026).

   La barra del contador es fija y no se anima (tio-cyber.css). Aca no hay
   listeners de scroll ni animacion por JS: un intervalo de 1 s que
   cambia textos, y un clic.
   ============================================================ */
(function () {
  'use strict';

  /* ---------------- Contador ---------------- */
  var cajas = document.querySelectorAll('[data-tio-cyber]');

  function dos(n) { return (n < 10 ? '0' : '') + n; }

  function poner(nodo, texto) {
    if (nodo && nodo.textContent !== texto) nodo.textContent = texto;
  }

  var reloj = 0;

  /* segundos que faltan para la medianoche de hoy, de 0 a 86399 */
  function hastaMedianoche(ahora) {
    var hoy = new Date(ahora);
    var manana = new Date(hoy.getFullYear(), hoy.getMonth(), hoy.getDate() + 1);
    return Math.min(86399, Math.floor((manana - hoy) / 1000));
  }

  function pintar() {
    var ahora = Date.now();
    var vivas = 0;
    for (var i = 0; i < cajas.length; i++) {
      var caja = cajas[i];
      var fin = Number(caja.getAttribute('data-fin')) * 1000;
      var resta = Math.floor((fin - ahora) / 1000);
      if (!(resta > 0)) {
        if (!caja.hasAttribute('data-diario')) { caja.hidden = true; continue; }
        resta = hastaMedianoche(ahora);
      }
      vivas++;
      var d = Math.floor(resta / 86400);
      /* la caja de los dias (y sus dos puntos) solo existe con dias */
      var cajaD = caja.querySelector('[data-tio-cyber-caja-d]');
      var sepD = caja.querySelector('[data-tio-cyber-sep-d]');
      if (cajaD) cajaD.hidden = d < 1;
      if (sepD) sepD.hidden = d < 1;
      poner(caja.querySelector('[data-tio-cyber-d]'), String(d));
      poner(caja.querySelector('[data-tio-cyber-h]'), dos(Math.floor((resta % 86400) / 3600)));
      poner(caja.querySelector('[data-tio-cyber-m]'), dos(Math.floor((resta % 3600) / 60)));
      poner(caja.querySelector('[data-tio-cyber-s]'), dos(resta % 60));
    }
    if (!vivas) {
      clearInterval(reloj);
      document.body.classList.remove('tio-cyber');
    }
  }

  if (cajas.length) {
    pintar();
    reloj = setInterval(pintar, 1000);
    /* al volver a la pestana el navegador pudo haber frenado el intervalo */
    document.addEventListener('visibilitychange', function () {
      if (!document.hidden) pintar();
    });
  }

  /* ---------------- Copiar el codigo ---------------- */
  var AVISO = 1800;      /* cuanto dura el "Copiado" */

  /* Camino viejo, para navegadores sin portapapeles asincrono. */
  function copiarAntiguo(texto) {
    return new Promise(function (listo, fallo) {
      var t = document.createElement('textarea');
      t.value = texto;
      t.setAttribute('readonly', '');
      t.style.position = 'fixed';
      t.style.top = '0';
      t.style.opacity = '0';
      document.body.appendChild(t);
      t.select();
      var hecho = false;
      try { hecho = document.execCommand('copy'); } catch (e) { hecho = false; }
      document.body.removeChild(t);
      if (hecho) listo(); else fallo();
    });
  }

  function copiar(texto) {
    if (navigator.clipboard && navigator.clipboard.writeText) {
      return navigator.clipboard.writeText(texto).catch(function () { return copiarAntiguo(texto); });
    }
    return copiarAntiguo(texto);
  }

  /* El aviso solo aparece si de verdad se copio. */
  function avisar(boton) {
    var rotulo = boton.querySelector('[data-tio-cyber-rotulo]');
    if (rotulo && boton._tioRotulo === undefined) boton._tioRotulo = rotulo.textContent;
    if (rotulo) rotulo.textContent = boton.getAttribute('data-copiado') || 'Copiado';
    boton.classList.add('is-copiado');
    clearTimeout(boton._tioReloj);
    boton._tioReloj = setTimeout(function () {
      if (rotulo) rotulo.textContent = boton._tioRotulo;
      boton.classList.remove('is-copiado');
    }, AVISO);
  }

  document.addEventListener('click', function (e) {
    var boton = e.target.closest('[data-tio-cyber-copiar]');
    if (!boton) return;
    var codigo = boton.getAttribute('data-codigo');
    if (!codigo) return;
    copiar(codigo).then(function () { avisar(boton); }, function () {});
  });
})();
